const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Assessments Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('overviewAssessmentsController', ['Authorization', 'AssessmentHost', 'AccessHelper', function(Authorization, AssessmentHost, AccessHelper) {
  var self = this;
  self.circleStats = {
    totalAssessments: 0,
    totalSubmissions30: 0,
    awaiting30: 0,
    passed30: 0
  };

  self.contentCurrentTab = '';

  self.tabAccessed = {};

  self.changeTab = function(tab) {
    self.tabAccessed[tab] = true;
    self.contentCurrentTab = tab;
  };

  self.tabAccess = {
    assessments_create: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
      ['admin', 'content', 'assessments_create'],
    ], ['admin', 'creator', 'collaborator']),
    assessments: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [
      ['admin', 'content', 'all_edit'],
      ['admin', 'content', 'assessments_create'],
      ['admin', 'content', 'assessments_edit'],
      ['admin', 'content', 'all_analytics'],
      ['admin', 'content', 'assessments_analytics']
    ], ['admin', 'creator', 'collaborator']),
  };

  self.tabAccess.archived = self.tabAccess.assessments && AccessHelper.isAllowed(['admin', 'content', 'unarchive_content'], null, ['admin']);

  if (self.tabAccess.assessments) {
    self.tabAccessed.assessments = true;
    self.contentCurrentTab = 'assessments';
  }

  self.isCollaborator = function() {
    return Authorization.isCollaborator();
  };

  AssessmentHost.overviewStats().$promise
      .then(function(results) {
        Object.assign(self.circleStats, results);
        for (var key in self.circleStats) {
          if (self.circleStats[key] < 0) {
            self.circleStats[key] = 0;
          }
        }
      }).catch(function(error) {
    console.log('error in stats: ', error);
  });

}]);